import { DefaultParams } from '../../default-params.model';

import { ApiBaseMidBack } from './base';
import { TemporaryTransactionViewModel } from './types/temporaryTransactionViewModel';

/**
 * @internal
 */
export class ApiEgmaTransaction extends ApiBaseMidBack {
  getTemporaryTransactions(
    contractIds?: number[],
    salesIds?: number[],
    startTradeDate?: string,
    endTradeDate?: string,
    states?: string[],
    transactionIds?: number[],
  ) {
    const params = {};
    if (contractIds) params['ContractIds'] = contractIds;
    if (startTradeDate) params['StartTradeDate'] = startTradeDate;
    if (endTradeDate) params['EndTradeDate'] = endTradeDate;
    if (transactionIds) params['TransactionIds'] = transactionIds;
    if (states) params['States'] = states;
    if (salesIds) params['SaleIds'] = salesIds;
    return this.get<TemporaryTransactionViewModel[]>(`/egmatransaction/egma-transaction/temporary-transactions`, new DefaultParams(params));
  }
}
